import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

export const GetAllBonusEligibleTickets = gql`
  query GetAllBonusEligibleTickets($bonusMonth: String, $districtId: Int, $showProcessed: Boolean) {
    all_bonus_eligible_tickets(month: $bonusMonth, district_id: $districtId, include_complete: $showProcessed) {
      edges {
        node {
          id
          date {
            display
          }
          ticket_number {
            id
            number
          }
        }
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const allTickets = querySelector(data, '$.all_bonus_eligible_tickets.edges[*].node', []);
  return {
    ...ownProps,
    data,
    allTickets,
  };
};

const queryGetAllBonusEligibleTickets = graphql(GetAllBonusEligibleTickets, {
  props: marshallData,
});

export const queryGetAllMonthlyBonusTicketsGQL = compose(
  queryGetAllBonusEligibleTickets,
  queryMetaHandler,
  omitProps(['data']),
);
